import React from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import { connect } from "react-redux";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import black from "sushiweb/tokens/color/black";
import Table from "../../Common/Table";
import TableFields from "../../../constants/FeatureConfig/RulesTableFields.json";
import { getPath } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import { RULE_SUB_TYPES } from "../../../constants/FeatureConfig/constants";
import BlankStateV2 from "../../Common/BlankStateV2";

const RulesModal = (props) => {
  const { activeRules, handleClose } = props;
  const allActions = MenuActionsMappings[MenuNames.FEATURE_CONFIG];

  const getFieldValue = (rule, key, index) => {
    switch (key) {
      case "number":
        return <p style={{ fontSize: "1rem" }}>{index + 1}</p>;
      case "baseRule":
        let data;
        const subType = getPath(rule, "subType", {});
        if (subType == RULE_SUB_TYPES.NOTIFICATION) {
          data = getPath(rule, key, {});
        } else if (subType == RULE_SUB_TYPES.VALIDATION) {
          const baseRule = getPath(rule, key, {});
          data = JSON.parse(getPath(baseRule, "Schema", {}));
        }
        return (
          <div>
            <JSONInput
              id="jsonInput"
              placeholder={data}
              locale={locale}
              height="100px"
              width="auto"
              viewOnly={true}
              colors={{
                string: "#FA7921",
                number: "#50B547",
                background: "#00000000",
                keys: "#1E1E1E",
                default: black,
              }}
              confirmGood={false}
              theme="light_mitsuketa_tribute"
            />
          </div>
        );
      default:
        return String(getPath(rule, key, "NA"));
    }
  };

  return (
    <NoFooterModal
      header={true}
      heading={`Rules`}
      handleClose={handleClose}
      id="RulesModal"
    >
      <Table
        list={activeRules}
        getFieldValue={getFieldValue}
        fields={TableFields}
        blankStateComponent={<BlankStateV2 heading={"No Rules"} />}
      />
    </NoFooterModal>
  );
};

export default connect()(RulesModal);
